export default (displayName?: string) => (displayName ? displayName.split(' ')[0] : '');
